// extracted by mini-css-extract-plugin
export default {"SelectorWrapper":"Select_SelectorWrapper__5FfcU","title":"Select_title__pTzhw","Select":"Select_Select__D1mzB","input":"Select_input__Sf2c-","inp_label":"Select_inp_label__39L4z"};